import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { CourseExercise } from 'redux/schemas/models/exercise';

export const getExercisesWithHardDeadline = createAsyncThunk(
  'GET_EXERCISES_WITH_HARD_DEADLINE',
  async (params: any) => axios.get(`${params.catalogId}/exercises/exercises_with_hard_deadline.json?user_id=${params.userId}`).then(response => response.data.result),
);

export const getFeatureableExercises = createAsyncThunk(
  'GET_FEATUREABLE_EXERCISES',
  async (catalogId: string) => axios.get(`/${catalogId}/exercises/featureable_exercises.json`).then(response => {
    const { result } = response.data;
    return (Array.isArray(result) ? result : Object.values(result || {})) as CourseExercise[];
  }),
);

export default getExercisesWithHardDeadline;
